import { render, staticRenderFns } from "./RunningHours.vue?vue&type=template&id=2bd8a857"
import script from "./RunningHours.vue?vue&type=script&lang=js"
export * from "./RunningHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports